import Loader from '../../containers/home/Loader';

export default Loader;